/* eslint-disable import/prefer-default-export */
export const binSize = 2
